<ol>
  <li *ngFor="let summary of ruleSummary">
    {{ summary }}
  </li>
</ol>